import styled from '@emotion/styled';

const AdChoicesLogo = styled('img')({
  height: '1rem',
  paddingLeft: '0.5rem',
});

export default AdChoicesLogo;
